import React, { useEffect } from "react";

const ReservationFeedbackModal = ({
  isOpen,
  type = "success",
  message = "",
  detailsMessage = "",
  context = null,
  onClose,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && typeof onClose === "function") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const isSuccess = type === "success";
  const participants = Number(context?.participants) || 1;
  const participantsLabel = participants > 1 ? "personnes" : "personne";
  const dateLabel = context?.dateLabel || "";
  const timeLabel = context?.timeLabel || "";
  const atelierLabel = context?.atelierLabel || "";
  const emailLabel = context?.email || "";
  const dateTimeLabel = [dateLabel, timeLabel].filter(Boolean).join(" à ");

  const defaultSuccessMessage = (
    <>
      <p className="mb-2">Votre réservation pour {participants} {participantsLabel} a été prise en compte 🎉</p>
      <p className="mb-2">
      Nous vous attendons le {dateTimeLabel || "créneau sélectionné"}{" "}
      {atelierLabel ? `pour un atelier ${atelierLabel}` : "pour l'atelier sélectionné"}.
      </p>
      <p className="mb-2">{emailLabel ? ` Vous allez recevoir un mail à ${emailLabel} de confirmation.` : ""}
        </p>
    </>
  );

  const defaultErrorMessage = (
    <>
      Désolé, un problème est survenu lors de la réservation. Nous vous invitons à contacter l'équipe Mood.{" "}
      <a className="text-orange-600 underline" href="/contact">
        Cliquez ici
      </a>
      .
    </>
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div
        className="relative z-10 w-full max-w-lg mx-4 rounded-xl bg-white p-6 shadow-xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="reservation-feedback-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h3
          id="reservation-feedback-title"
          className={`text-lg font-semibold ${isSuccess ? "text-green-700" : "text-red-600"}`}
        >
          {isSuccess ? "Réservation confirmée" : "Réservation impossible"}
        </h3>
        <p className="mt-3 text-sm text-gray-700 leading-relaxed">
          {message ? message : isSuccess ? defaultSuccessMessage : defaultErrorMessage}
        </p>

        <div className="mt-6 flex justify-end">
          <button
            type="button"
            className="bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700"
            onClick={onClose}
          >
            C'est noté
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReservationFeedbackModal;
